import { render, staticRenderFns } from "./statusChangeHistoryDialog.vue?vue&type=template&id=3ddd2055&"
import script from "./statusChangeHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./statusChangeHistoryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ddd2055')) {
      api.createRecord('3ddd2055', component.options)
    } else {
      api.reload('3ddd2055', component.options)
    }
    module.hot.accept("./statusChangeHistoryDialog.vue?vue&type=template&id=3ddd2055&", function () {
      api.rerender('3ddd2055', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/statusChangeHistoryDialog.vue"
export default component.exports